export function jsonTryParse<T>(json: string, defaultValue: T): T {
  try {
    return json ? JSON.parse(json) : defaultValue
  } catch (e) {
    return defaultValue
  }
}
